import React from "react";

export const InfoRow: React.FC<{
  label: string;
  value?: string;
  action?: React.ReactNode;
}> = ({ label, value, action }) => (
  <div className="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0">
    <div>
      <p className="text-[11px] text-gray-400 mb-0.5">{label}</p>
      <p className="text-sm font-medium text-gray-700 mb-0">{value || "—"}</p>
    </div>
    {action}
  </div>
);
